import { Pipe, PipeTransform } from '@angular/core';
import { checkSOHValid, convertNumberFormat, getMonthShortcut, notEmptyNullUndefined, notNullUndefined } from 'src/app/helpers/utils';
import { PoSku, PoUiTable1 } from 'src/app/models/data/po-relate.model';
import NP from 'number-precision'
@Pipe({
  name: 'convertPoSkuTableReadableType'
})
export class ConvertPoSkuTableReadableTypePipe implements PipeTransform {

  transform(poSku: PoSku): PoUiTable1[] {
    const language: string = "en-AU"
    const mthsRange = 6
    const currentMonth = new Date().getMonth()
    const titleEnding = 'SOH at the end of '
    const channels = JSON.parse(JSON.stringify(poSku.channels))
    const planningColumn = this.getMonthNumber(poSku.planning_month)
    //const channels = [...poSku.channels]
    console.log(channels)
    const uiDisplayChannels = notEmptyNullUndefined(channels) ? channels.map((c): PoUiTable1 => {
      console.log(c)
      return {
        channel: { content: c?.channel_name, font_color: 'black', font_bold: true },
        mlor: { content: notNullUndefined(c?.mlor) ? convertNumberFormat(language ,c.mlor).toString() : null, font_color: 'black', font_bold: false, selectedMonth: planningColumn == 0 ? true : false},
        forecast1: { content: notNullUndefined(c?.forecast[0]) ? convertNumberFormat(language ,c.forecast[0]).toString() : null, font_color: 'black', font_bold: false, selectedMonth: planningColumn == 1 ? true : false },
        forecast2: { content: notNullUndefined(c?.forecast[1]) ? convertNumberFormat(language ,c.forecast[1]).toString() : null, font_color: 'black', font_bold: false, selectedMonth: planningColumn == 2 ? true : false },
        forecast3: { content: notNullUndefined(c?.forecast[2]) ? convertNumberFormat(language ,c.forecast[2]).toString() : null, font_color: 'black', font_bold: false, selectedMonth: planningColumn == 3 ? true : false },
        forecast4: { content: notNullUndefined(c?.forecast[3]) ? convertNumberFormat(language ,c.forecast[3]).toString() : null, font_color: 'black', font_bold: false, selectedMonth: planningColumn == 4 ? true : false },
        forecast5: { content: notNullUndefined(c?.forecast[4]) ? convertNumberFormat(language ,c.forecast[4]).toString() : null, font_color: 'black', font_bold: false, selectedMonth: planningColumn == 5 ? true : false },
        forecast6: { content: notNullUndefined(c?.forecast[5]) ? convertNumberFormat(language ,c.forecast[5]).toString() : null, font_color: 'black', font_bold: false},
      }
    }) : []

    const uiDisplayBbdHeader = {
      channel: { content: "BBD", font_color: 'black', font_bold: true },
      mlor: { content: titleEnding + getMonthShortcut(currentMonth % 12), font_color: 'black', font_bold: true },
      forecast1: { content: titleEnding + getMonthShortcut((currentMonth + 1) % 12), font_color: 'black', font_bold: true },
      forecast2: { content: titleEnding + getMonthShortcut((currentMonth + 2) % 12), font_color: 'black', font_bold: true },
      forecast3: { content: titleEnding + getMonthShortcut((currentMonth + 3) % 12), font_color: 'black', font_bold: true },
      forecast4: { content: titleEnding + getMonthShortcut((currentMonth + 4) % 12), font_color: 'black', font_bold: true },
      forecast5: { content: titleEnding + getMonthShortcut((currentMonth + 5) % 12), font_color: 'black', font_bold: true },
      forecast6: { content: null, font_color: 'black', font_bold: true },
    }
    const batches = [...poSku.sku_batches]
    const uiDisplayBatches = batches.map((b): PoUiTable1 => {
      return {
        channel: { content: this.convert(b?.bbd), font_color: 'black', font_bold: true },
        mlor: { content: notNullUndefined(b?.months[0]?.qty) ? convertNumberFormat(language, b?.months[0]?.qty).toString() : null, font_color: b?.months[0]?.expired ? 'red' : 'black', font_bold: false, selectedMonth: planningColumn == 0 ? true : false },
        forecast1: { content: notNullUndefined(b?.months[1]?.qty) ? convertNumberFormat(language ,b?.months[1]?.qty).toString() : null, font_color: b?.months[1]?.expired ? 'red' : 'black', font_bold: false, selectedMonth: planningColumn == 1 ? true : false },
        forecast2: { content: notNullUndefined(b?.months[2]?.qty) ? convertNumberFormat(language ,b?.months[2]?.qty).toString() : null, font_color: b?.months[2]?.expired ? 'red' : 'black', font_bold: false, selectedMonth: planningColumn == 2 ? true : false },
        forecast3: { content: notNullUndefined(b?.months[3]?.qty) ? convertNumberFormat(language ,b?.months[3]?.qty).toString() : null, font_color: b?.months[3]?.expired ? 'red' : 'black', font_bold: false, selectedMonth: planningColumn == 3 ? true : false },
        forecast4: { content: notNullUndefined(b?.months[4]?.qty) ? convertNumberFormat(language ,b?.months[4]?.qty).toString() : null, font_color: b?.months[4]?.expired ? 'red' : 'black', font_bold: false, selectedMonth: planningColumn == 4 ? true : false },
        forecast5: { content: notNullUndefined(b?.months[5]?.qty) ? convertNumberFormat(language ,b?.months[5]?.qty).toString() : null, font_color: b?.months[5]?.expired ? 'red' : 'black', font_bold: false, selectedMonth: planningColumn == 5 ? true : false },
        forecast6: { content: null, font_color: 'black', font_bold: false },
      }
    })

    //calculate PO
    //get the time range first and put in array
    //then find and add the poQty base on the same ETA mths
    let months = new Array(mthsRange).fill(0);
    for(var i = 0; i< mthsRange; i++){
      months[i] = ((currentMonth+i) % 12) +1 //start from 0
    }
    const poSumOfMths = months.map(m =>{
      let result = 0
      //find same months and add to sum
      poSku?.po_qty?.filter(po=>{
        const poEtaMonth = Number(po.eta.slice(4, 6))
        if(poEtaMonth===m){
          return true
        }else{
          return false
        }
      })?.forEach(po=>{
        result+=po.qty
      })
      return result===0?'': convertNumberFormat(language ,result).toString()
    })
    const skuNatPoQty = {
      channel: { content: 'PO ETA', font_color: 'black', font_bold: true },
      mlor: { content: poSumOfMths[0], font_color: 'green', font_bold: false, selectedMonth: planningColumn == 0 ? true : false },
      forecast1: { content: poSumOfMths[1], font_color: 'green', font_bold: false, selectedMonth: planningColumn == 1 ? true : false },
      forecast2: { content: poSumOfMths[2], font_color: 'green', font_bold: false, selectedMonth: planningColumn == 2 ? true : false },
      forecast3: { content: poSumOfMths[3], font_color: 'green', font_bold: false, selectedMonth: planningColumn == 3 ? true : false },
      forecast4: { content: poSumOfMths[4], font_color: 'green', font_bold: false, selectedMonth: planningColumn == 4 ? true : false },
      forecast5: { content: poSumOfMths[5], font_color: 'green', font_bold: false, selectedMonth: planningColumn == 5 ? true : false },
      forecast6: { content: null, font_color: 'black', font_bold: false },
    }

    let sumArray = new Array(mthsRange).fill(0);
    uiDisplayBatches.forEach(batch => {
      sumArray[0] += checkSOHValid(batch.mlor)
      sumArray[1] += checkSOHValid(batch.forecast1)
      sumArray[2] += checkSOHValid(batch.forecast2)
      sumArray[3] += checkSOHValid(batch.forecast3)
      sumArray[4] += checkSOHValid(batch.forecast4)
      sumArray[5] += checkSOHValid(batch.forecast5)
    })
    console.log(sumArray)
    const uiDisplayPO = {
      channel: { content: 'Total SOH', font_color: 'black', font_bold: true },
      mlor: { content: convertNumberFormat(language ,NP.plus(sumArray[0], this.sumEta(poSumOfMths,1))).toString(), font_color: 'black', font_bold: false, selectedMonth: planningColumn == 0 ? true : false },
      forecast1: { content: convertNumberFormat(language ,NP.plus(sumArray[1], this.sumEta(poSumOfMths,2))).toString(), font_color: 'black', font_bold: false, selectedMonth: planningColumn == 1 ? true : false },
      forecast2: { content: convertNumberFormat(language ,NP.plus(sumArray[2], this.sumEta(poSumOfMths,3))).toString(), font_color: 'black', font_bold: false, selectedMonth: planningColumn == 2 ? true : false },
      forecast3: { content: convertNumberFormat(language ,NP.plus(sumArray[3], this.sumEta(poSumOfMths,4))).toString(), font_color: 'black', font_bold: false, selectedMonth: planningColumn == 3 ? true : false },
      forecast4: { content: convertNumberFormat(language ,NP.plus(sumArray[4], this.sumEta(poSumOfMths,5))).toString(), font_color: 'black', font_bold: false, selectedMonth: planningColumn == 4 ? true : false },
      forecast5: { content: convertNumberFormat(language ,NP.plus(sumArray[5], this.sumEta(poSumOfMths,6))).toString(), font_color: 'black', font_bold: false, selectedMonth: planningColumn == 5 ? true : false },
      forecast6: { content: null, font_color: 'black', font_bold: false },
    }
    console.log([...uiDisplayChannels,uiDisplayBbdHeader,...uiDisplayBatches,uiDisplayPO])
     return [...uiDisplayChannels,uiDisplayBbdHeader,...uiDisplayBatches,skuNatPoQty,uiDisplayPO]
  }





  private convert=(dateString:string)=> {
    if (!dateString || (dateString.length !== 6 && dateString.length !== 8)) {
      return 'Invalid Date';
    }

    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);

    const monthName = this.getMonthName(parseInt(month, 10));

    return `${monthName} ${day}, ${year}`;
  }

  private getMonthName=(month: number): string =>{
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    if (month >= 1 && month <= 12) {
      return months[month - 1];
    } else {
      return 'Invalid Month';
    }
  }

  private getMonthNumber = (dateString:string) : number | string => {
    if (!dateString || dateString.length !== 6) {
      return 'Invalid Date';
    }

    const currentMonth = new Date().getMonth()
    const month = dateString.slice(4);
    const difference = Number(month) - currentMonth - 1

    return difference >= 0 ? difference : difference + 12
  }

  private sumEta = (array, number) => {
    let result = 0
    for(let i = 0; i < number; i++) {
      //console.log('result', array[i])
      result += array[i] ? Number(array[i].split(',').join('')) : 0
    }
    return result
  }
}



